import { Topics } from "../conf/Config";
import WebSocketClient from "../modules/WebSocketClient";

export default class MarketViewController {

    constructor() {
        // this.topics = [
        //     Topics.marketThumb,
        // ];
        // this.onTopicMessage = this.onTopicMessage.bind(this);
        // this.subscribeTopic = this.subscribeTopic.bind(this);
    }

    init() {
        // this.subscribeTopic();
    }

    destroy() {
        // this.unsubscribeTopic();
    }

    subscribeTopic() {
        // this.topics.forEach(t => {
        //     WebSocketClient.subscribe(t, this.onTopicMessage)
        // })
    }

    unsubscribeTopic() {
        // this.topics.forEach(t => {
        //     WebSocketClient.unsubscribe(t, this.onTopicMessage)
        // })
    }

    onTopicMessage(topic, message) {
        // if (topic == Topics.marketThumb) {
        //     const thumb = JSON.parse(message.body);
        //     for (const id in thumb) {
        //         DataCenter.updateThumbData(id, thumb[id]);
        //     }
        // }
    }

}